import { defaultEntityState, IEntityState } from '@core/state/entities/entity';
import {
  normalizeAndMergeEntity,
  mergeEntityState,
  removeEntitiesWithIds,
} from '@core/state/entities/entity.helpers';
import {
  IScreening,
  screeningSchema,
} from '@core/state/entities/screening/screening.entity';
import { studyOutgoingDtoSchema } from '@core/services/stage/review-effects';
import { createReducer, on } from '@ngrx/store';
import {
  incompleteStudiesPayloadSchema,
  stageActions,
  stageStudyActions,
} from '@core/actions/stage.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const screeningEntityReducer = createReducer(
  defaultEntityState<IScreening>(),
  on(stageStudyActions.receivedStageStudy, (state, props) =>
    mergeEntityState(entityKey.screenings, state, props)
  ),

  on(stageActions.submitScreeningAndNextStudy, (state, props) =>
    normalizeAndMergeEntity(entityKey.screenings, state, props, {
      screening: screeningSchema,
    })
  ),
  // Revision-2 §4.3: recording a decision and staying puts the same screening
  // in state as recording one and advancing. Only the navigation differs.
  on(
    stageActions.submitScreeningWithoutAdvancing,
    (state, props): IEntityState<IScreening> =>
      normalizeAndMergeEntity(entityKey.screenings, state, props, {
        screening: screeningSchema,
      })
  ),
  // The write above is optimistic and the reviewer is still on the study, so
  // a refused decision has to be undone here: leaving it would show a decided
  // strip -- with Include and Exclude hidden behind it -- for a decision the
  // server never accepted.
  // Same hazard on the advancing path: when the write is refused nothing
  // persisted and no next study loaded, so the reviewer is still looking at
  // this study and must not be shown a decision on it.
  on(
    stageActions.submitScreeningAndNextStudyFailure,
    (state, props): IEntityState<IScreening> =>
      props.confirmedScreening
        ? normalizeAndMergeEntity(
            entityKey.screenings,
            state,
            { screening: props.confirmedScreening },
            { screening: screeningSchema }
          )
        : removeEntitiesWithIds(state, [props.screening.id])
  ),
  on(
    stageActions.submitScreeningWithoutAdvancingFailure,
    (state, props): IEntityState<IScreening> =>
      props.confirmedScreening
        ? normalizeAndMergeEntity(
            entityKey.screenings,
            state,
            { screening: props.confirmedScreening },
            { screening: screeningSchema }
          )
        : removeEntitiesWithIds(state, [props.screening.id])
  ),
  on(stageActions.receivedInProgressStudies, (state, props) =>
    mergeEntityState(entityKey.screenings, state, props)
  ),
  on(stageActions.incompleteSessionsUpdated, (state, props) =>
    normalizeAndMergeEntity(
      entityKey.screenings,
      state,
      props,
      incompleteStudiesPayloadSchema
    )
  ),
  on(stageActions.saveSession, (state, props) =>
    props.correlationId !== undefined
      ? state
      : normalizeAndMergeEntity(
          entityKey.screenings,
          state,
          props,
          studyOutgoingDtoSchema
        )
  )
);
